export const generateQueryParamsStr = (availableQueryParamsList = [], receivedParamsObj = {}) => {
    let queryParams = [];
    for (let availableParam of availableQueryParamsList) {
        if (receivedParamsObj.hasOwnProperty(availableParam)) {
            const value = receivedParamsObj[availableParam];
            if (value !== undefined && value !== null) {
                queryParams.push(`${availableParam}=${encodeURIComponent(String(value))}`);
            }
        }
    }
    return queryParams.join('&');
};
